import axios from "axios";
import React, { Suspense, useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import Layout from "../components/Layout";
import Particle from "../components/Particle";
import Socialicons from "../components/Socialicons";
import Spinner from "../components/Spinner";

function Home({ lightMode }) {
  const [information, setInformation] = useState("");

  useEffect(() => {
    axios.get("/api/information").then((response) => {
      setInformation(response.data);
    });
  }, []);

  return (
    <Layout>
      <Helmet>
        <title>Home</title>
        <meta
          name="description"
          content="Emily Hoang - Homepage"
        />
      </Helmet>
      <Suspense fallback={<Spinner />}>
        <div className="mi-home-area mi-padding-section">
          <Particle lightMode={lightMode} />
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-10 col-12">
                <div className="mi-home-content">
                  <h1>
                    Hi, my name is {" "}
                    <span className="color-theme">{information.name}</span>
                  </h1>
                  <div>
                    <p>
                      {information.aboutContent1}
                    </p>
                    <p>
                      {information.aboutContent2}
                    </p>
                    <p>
                      {information.aboutContent3}
                    </p>
                    <p>
                      {information.aboutContent4}
                    </p>
                    <p>
                      {information.aboutContent5}
                    </p>
                  </div>
                  <Socialicons bordered />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Suspense>
    </Layout>
  );
}

export default Home;
